import Swiper, { Lazy, Autoplay, Pagination, Keyboard, EffectFade } from 'swiper'

Swiper.use([Lazy, Autoplay, Pagination, Keyboard, EffectFade])

import swiperHandleKeyboardFocus from '@js/util/swiper-handle-keyboard-focus'

for (let sliderElement of document.querySelectorAll('.wpce-slider-integrated')) {
  let swiper = new Swiper(
    `#${sliderElement.dataset.swiperId}`,
    JSON.parse(sliderElement.dataset.options),
  )
  swiperHandleKeyboardFocus(swiper)
}
